import React, { useState } from 'react';
import { ChevronDown, Grid, Calendar, Users, FlaskConical, BarChart2, Image as ImageIcon, Clipboard, Upload, MoreHorizontal } from 'lucide-react';
import Header from "../../components/Header";

const Dashboard = () => {
  const [expandedMenus, setExpandedMenus] = useState({
    monitoring: false,
    imageDiagnostic: true,
    surgicalPlanning: false,
    labExams: false
  });

  const toggleMenu = (menu) => {
    setExpandedMenus({
      ...expandedMenus,
      [menu]: !expandedMenus[menu]
    });
  };

  return (
    <div className="flex flex-col h-screen bg-gray-100">
      <Header title="Dashboard" />
      <div className="flex flex-col md:flex-row flex-1">
      {/* Sidebar */}
      <div className="w-full md:w-64 bg-blue-900 text-white flex flex-col">
        {/* Logo */}
        <div className="p-4 bg-blue-900">
          <div className="flex items-center">
            <div className="mr-2">
              <svg viewBox="0 0 100 100" width="40" height="40" fill="white">
                <path d="M50,10 C27.91,10 10,27.91 10,50 C10,72.09 27.91,90 50,90 C72.09,90 90,72.09 90,50 C90,27.91 72.09,10 50,10 Z M50,30 C59.94,30 68,38.06 68,48 C68,57.94 59.94,66 50,66 C40.06,66 32,57.94 32,48 C32,38.06 40.06,30 50,30 Z" />
                <path d="M50,20 C33.43,20 20,33.43 20,50 C20,66.57 33.43,80 50,80 C66.57,80 80,66.57 80,50 C80,33.43 66.57,20 50,20 Z M50,40 C55.52,40 60,44.48 60,50 C60,55.52 55.52,60 50,60 C44.48,60 40,55.52 40,50 C40,44.48 44.48,40 50,40 Z" />
              </svg>
            </div>
            <div>
              <div className="text-2xl font-bold">ORCA</div>
              <div className="text-xs">OPTIMIZED RESPONSIVE CLINICAL ANALYSIS</div>
            </div>
          </div>
        </div>

        {/* Navigation Menu */}
        <nav className="flex-1 overflow-y-auto">
          <div className="p-2">
            <a href="#" className="flex items-center p-2 rounded hover:bg-blue-800 mb-1">
              <Grid className="mr-2" size={20} />
              <span>Dashboard</span>
            </a>

            <a href="#" className="flex items-center p-2 rounded hover:bg-blue-800 mb-1">
              <Calendar className="mr-2" size={20} />
              <span>Agenda</span>
              <span className="ml-auto bg-blue-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">3</span>
            </a>

            <a href="#" className="flex items-center p-2 rounded hover:bg-blue-800 mb-1">
              <Users className="mr-2" size={20} />
              <span>Pacientes</span>
            </a>

            <div className="mb-1">
              <button 
                onClick={() => toggleMenu('monitoring')} 
                className="w-full flex items-center p-2 rounded hover:bg-blue-800"
              >
                <BarChart2 className="mr-2" size={20} />
                <span>Monitoramento</span>
                <ChevronDown className={`ml-auto transition-transform ${expandedMenus.monitoring ? 'rotate-180' : ''}`} size={16} />
              </button>
              {expandedMenus.monitoring && (
                <div className="pl-6">
                  {/* Monitoring submenu items would go here */}
                </div>
              )}
            </div>

            <div className="mb-1">
              <button 
                onClick={() => toggleMenu('imageDiagnostic')} 
                className={`w-full flex items-center p-2 rounded ${expandedMenus.imageDiagnostic ? 'bg-blue-800' : 'hover:bg-blue-800'}`}
              >
                <ImageIcon className="mr-2" size={20} />
                <span>Diagnóstico por Imagem</span>
                <ChevronDown className={`ml-auto transition-transform ${expandedMenus.imageDiagnostic ? 'rotate-180' : ''}`} size={16} />
              </button>
              {expandedMenus.imageDiagnostic && (
                <div className="pl-6">
                  <a href="#" className="flex items-center p-2 rounded bg-blue-700 mb-1">
                    <span className="mr-2">•</span>
                    <span>Raio-X</span>
                  </a>
                  <a href="#" className="flex items-center p-2 rounded hover:bg-blue-800 mb-1">
                    <span className="mr-2">•</span>
                    <span>Ultrassom</span>
                  </a>
                  <a href="#" className="flex items-center p-2 rounded hover:bg-blue-800 mb-1">
                    <span className="mr-2">•</span>
                    <span>Ecocardiograma</span>
                  </a>
                  <a href="#" className="flex items-center p-2 rounded hover:bg-blue-800 mb-1">
                    <span className="mr-2">•</span>
                    <span>Eletrocardiograma</span>
                  </a>
                </div>
              )}
            </div>

            <div className="mb-1">
              <button 
                onClick={() => toggleMenu('surgicalPlanning')} 
                className="w-full flex items-center p-2 rounded hover:bg-blue-800"
              >
                <Clipboard className="mr-2" size={20} />
                <span>Planejamento Cirúrgico</span>
                <ChevronDown className={`ml-auto transition-transform ${expandedMenus.surgicalPlanning ? 'rotate-180' : ''}`} size={16} />
              </button>
              {expandedMenus.surgicalPlanning && (
                <div className="pl-6">
                  <a href="#" className="flex items-center p-2 rounded hover:bg-blue-800 mb-1">
                    <span className="mr-2">•</span>
                    <span>Ortopédico</span>
                  </a>
                  <a href="#" className="flex items-center p-2 rounded hover:bg-blue-800 mb-1">
                    <span className="mr-2">•</span>
                    <span>Planejamento Anestésico</span>
                  </a>
                </div>
              )}
            </div>

            <div className="mb-1">
              <button 
                onClick={() => toggleMenu('labExams')} 
                className="w-full flex items-center p-2 rounded hover:bg-blue-800"
              >
                <FlaskConical className="mr-2" size={20} />
                <span>Exames Laboratoriais</span>
                <ChevronDown className={`ml-auto transition-transform ${expandedMenus.labExams ? 'rotate-180' : ''}`} size={16} />
              </button>
              {expandedMenus.labExams && (
                <div className="pl-6">
                  <a href="#" className="flex items-center p-2 rounded hover:bg-blue-800 mb-1">
                    <span className="mr-2">•</span>
                    <span>Hemograma</span>
                  </a>
                  <a href="#" className="flex items-center p-2 rounded hover:bg-blue-800 mb-1">
                    <span className="mr-2">•</span>
                    <span>Bioquímico</span>
                  </a>
                  <a href="#" className="flex items-center p-2 rounded hover:bg-blue-800 mb-1">
                    <span className="mr-2">•</span>
                    <span>Urinálise</span>
                  </a>
                </div>
              )}
            </div>
          </div>
        </nav>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-auto">
        {/* Header */}
        <header className="bg-white p-4 shadow flex justify-between items-center">
          <div className="flex items-center">
            <div className="flex items-center font-bold text-blue-900 mr-6">
              <svg viewBox="0 0 24 24" width="20" height="20" className="mr-2 fill-current">
                <path d="M12 2L8 6H4V10L0 12L4 14V18H8L12 22L16 18H20V14L24 12L20 10V6H16L12 2Z" />
              </svg>
              RAIO X
            </div>
          </div>
          <div className="flex">
            <button className="px-4 py-2 bg-gray-100 text-gray-700 rounded mr-2">Tela inicial</button>
            <button className="px-4 py-2 bg-blue-500 text-white rounded">Configurações</button>
            <button className="ml-2 p-2 text-gray-500">
              <MoreHorizontal size={20} />
            </button>
          </div>
        </header>

        {/* Content */}
        <div className="p-4">
          {/* X-Ray Images Section */}
          <div className="bg-white rounded-lg shadow mb-6">
            <div className="p-4 flex justify-between items-center border-b">
              <h2 className="font-semibold">ADICIONAR IMAGEM</h2>
              <button className="text-gray-500">
                <MoreHorizontal size={20} />
              </button>
            </div>
            <div className="p-4 grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="col-span-1">
                <img src="/api/placeholder/400/300" alt="X-ray" className="w-full h-auto rounded" />
              </div>
              <div className="col-span-1">
                <img src="/api/placeholder/400/300" alt="X-ray" className="w-full h-auto rounded" />
              </div>
              <div className="col-span-1 flex items-center justify-center border-2 border-dashed border-gray-300 rounded-lg p-6">
                <div className="text-center">
                  <Upload className="mx-auto text-gray-400 mb-2" size={48} />
                </div>
              </div>
            </div>
          </div>

          {/* Patient Description */}
          <div className="bg-white rounded-lg shadow mb-6">
            <div className="p-4 flex justify-between items-center border-b">
              <h2 className="font-semibold">DESCRIÇÃO DO PACIENTE</h2>
              <button className="text-gray-500">
                <MoreHorizontal size={20} />
              </button>
            </div>
            <div className="p-4 grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* Species */}
              <div className="col-span-1 border rounded-lg p-4">
                <h3 className="font-medium mb-3">ESPÉCIE</h3>
                <div className="space-y-2">
                  <label className="flex items-center">
                    <input type="checkbox" className="mr-2" checked />
                    <span>Canino</span>
                  </label>
                  <label className="flex items-center">
                    <input type="checkbox" className="mr-2" />
                    <span>Felino</span>
                  </label>
                  <label className="flex items-center">
                    <input type="checkbox" className="mr-2" />
                    <span>Equino</span>
                  </label>
                  <label className="flex items-center">
                    <input type="checkbox" className="mr-2" />
                    <span>Outros</span>
                  </label>
                </div>
              </div>

              {/* Dog Illustration */}
              <div className="col-span-1 flex justify-center items-center p-4">
                <div>
                  <img src="/api/placeholder/200/200" alt="Dog Skeleton" className="mx-auto" />
                </div>
              </div>

              {/* Region */}
              <div className="col-span-1 border rounded-lg p-4">
                <h3 className="font-medium mb-3">REGIÃO</h3>
                <div className="grid grid-cols-2 gap-2">
                  <label className="flex items-center">
                    <input type="checkbox" className="mr-2" checked />
                    <span>Torax</span>
                  </label>
                  <label className="flex items-center">
                    <input type="checkbox" className="mr-2" />
                    <span>Coluna Cervical</span>
                  </label>
                  <label className="flex items-center">
                    <input type="checkbox" className="mr-2" />
                    <span>Coluna Torácica</span>
                  </label>
                  <label className="flex items-center">
                    <input type="checkbox" className="mr-2" />
                    <span>Coluna Lombar</span>
                  </label>
                  <label className="flex items-center">
                    <input type="checkbox" className="mr-2" />
                    <span>Estruturas ósseas</span>
                  </label>
                  <label className="flex items-center">
                    <input type="checkbox" className="mr-2" />
                    <span>Pelve</span>
                  </label>
                  <label className="flex items-center">
                    <input type="checkbox" className="mr-2" />
                    <span>Crânio</span>
                  </label>
                  <label className="flex items-center">
                    <input type="checkbox" className="mr-2" />
                    <span>Articulações</span>
                  </label>
                </div>
              </div>
            </div>

            <div className="p-4 grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* Breed */}
              <div className="col-span-1 border rounded-lg p-4">
                <h3 className="font-medium mb-3">RAÇA</h3>
                <div className="bg-gray-700 text-white p-2 rounded text-center">
                  LABRADOR
                </div>
              </div>

              {/* Age */}
              <div className="col-span-1 border rounded-lg p-4">
                <h3 className="font-medium mb-3">IDADE</h3>
                <div className="bg-gray-700 text-white p-2 rounded text-center">
                  13 anos
                </div>
              </div>

              {/* Analysis Type */}
              <div className="col-span-1 border rounded-lg p-4">
                <h3 className="font-medium mb-3">TIPO DE ANALISE</h3>
                <div className="space-y-2">
                  <label className="flex items-center">
                    <input type="checkbox" className="mr-2" checked />
                    <span>Clínica</span>
                  </label>
                  <label className="flex items-center">
                    <input type="checkbox" className="mr-2" />
                    <span>Laudo radiográfico</span>
                  </label>
                  <label className="flex items-center">
                    <input type="checkbox" className="mr-2" />
                    <span>Visual</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* History and Suspicions */}
          <div className="bg-white rounded-lg shadow">
            <div className="p-4 flex justify-between items-center border-b">
              <h2 className="font-semibold">HISTÓRICO E SUSPEITAS</h2>
              <button className="text-gray-500">
                <MoreHorizontal size={20} />
              </button>
            </div>
            <div className="p-4">
              <p>Paciente com suspeita de metástase</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Dashboard;